<div class="modal">
  <!--modal header-->
  <div class="modal__modal-header">
    {{'new-surrender-popup.header' | translate}}
  </div>

  <!--gasa cancellation dialog content-->
  
    <div class="modal__modal-content">

      <!--para-->
    <div class="modal__modal-content__para">
       {{'new-surrender-popup.text-1' | translate}}
        <span class="modal__modal-content__para__text-red"> {{'new-surrender-popup.text-2' | translate}}</span>
    </div>

    <!--gasa cancellation list -->
      <div class="modal__modal-content__cancellation-list">
      <ul>
        <li>
          {{'new-surrender-popup.text-3' | translate}}
          <span class="modal__modal-content__cancellation-list__text-bold"> {{'new-surrender-popup.text-4' | translate}}</span>
          {{'new-surrender-popup.text-5' | translate}}
        </li>
        <li>
          <span class="modal__modal-content__cancellation-list__text-bold">{{'new-surrender-popup.text-6' | translate}}</span>
        </li>
      </ul>
      </div> 
    </div>
  

  <!--mat dialog actions-->
  
    <div class="modal__modal-actions">

      <!--cancel button-->
        <button mat-flat-button color="accent" (click)="onCancel()"
          class="modal__modal-actions__cancel-btn">
             {{'new-surrender-popup.button-2' | translate}}
        </button>

        <!--proceed with the procedure-->
        <button mat-flat-button color="primary" (click)="onProceed()"
          class="modal__modal-actions__proceed-btn">
          {{'new-surrender-popup.button-1' | translate}}
        </button>
      
    </div>
  
</div>